import React  from 'react'
import LookupText from '../Elements/LookupText';
import UserNameComponent from '../Elements/UserNameComponent';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import JsxHelper from '../Helpers/JsxHelper';
import urlHelper from '../Helpers/urlHelper';
// import JsxHelper from '../Helpers/JsxHelper';
// import urlHelper from '../Helpers/urlHelper';

export default class ExportQueueItem
{
	constructor(item) 
	{
		if(item===undefined)
		{
			this.ExportQueueId = "";
			this.OfficeId = "";
			this.TypeId = "";
			this.ExportId = "";
			this.ResultText = "";
			this.Exception = "";
			this.StatusCode = "";
			this.StartedOn = "";
			this.FinishedOn = "";
			this.CreatedOn = "";
			this.CreatedBy = "";
			this.ModifiedOn = "";
			this.Tipalti = "";
			this.OfficeName = "";
			this.Yrmo = "";
		}
		else
		{
			this.initialize(item);
		}
	}

	async initialize(item)
	{
		this.ExportQueueId = item.exportQueueId; 
		this.OfficeId = item.officeId; 
		this.TypeId = item.typeId; 
		this.ExportId = item.exportId; 
		this.ResultText = item.resultText; 
		this.Exception = item.exception; 
		this.StatusCode = item.statusCode; 
		this.StartedOn = item.startedOn; 
		this.FinishedOn = item.finishedOn; 
		this.CreatedOn = item.createdOn; 
		this.CreatedBy = item.createdBy; 
		this.ModifiedOn = item.modifiedOn; 
		this.Tipalti = item.tipalti; 
		this.OfficeName = item.officeName; 
		this.Yrmo = item.yrmo; 
	}

	static NameOfTheIdField(){return "ExportQueueId";}
	static nameOfTheItemDetailList() {return "ExportQueue";}

	static MoneyFields= [];

	static Currency() {return ""};

	static MoneyFieldsSecondary= [];

	static CurrencySecondary(){return ""};

	static DateFields=["StartedOn","FinishedOn","CreatedOn", "ModifiedOn"];
	

	static BoolFields= ["Tipalti"];
	

	static FieldsToShowInListTable=[
		{tabName:"Info", tabLabel:"Info", icon:"fa-solid fa-info" , data:[
			{label:"Export Queue ID", name:"ExportQueueId"},
			{label:"Office Name", name:"OfficeName"},
			{label:"Export Type", name:item=>item.TypeId===1?"EOM":"Ad Hoc"},
			{label:"Export ID", name:"ExportId"},
			{label:"Result Text", name:"ResultText"},
			{label:"Status Code", name:item=><LookupText lookupId={70} value={item.StatusCode}/>},
			{label:"Exception", name:"Exception", width:TabListTableCellWidthEnum.TwoLines},
			{label:"Started On", name:item=>dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.StartedOn)},
			{label:"Created On", name:"CreatedOn"},
			{label:"Created By", name:item=><UserNameComponent userId={item.CreatedBy}/>},
			{label:"Finished On", name:item=>dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.FinishedOn)},
			{label:"Modified On", name:"ModifiedOn"},
			{label:"Tipalti", name:item=>JsxHelper.YesNo(item.Tipalti)},
		]},	
	];


	//Meaning of data field: 
	//   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field 
	//   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function 
	//			and the field shows the result of this function
	//   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
	static FieldsToShowInDataTable()
	{ 
		return [
			{label: "Export Queue Id", orderById: "ExportQueueId", data:"ExportQueueId",type: FieldTypesEnum.DataFieldWithDetails,  minWidth:50},
			{label: "Export Id", orderById: "ExportId", data:ExportQueueItem.GetDetailCellContent,  minWidth:50},
			{label: "Status", orderById: "StatusCode", data:(item)=><LookupText lookupId={70} value={item.StatusCode}/>,  minWidth:50, className:"text-left"},
			{label: "Result", orderById: "", data:"ResultText",  minWidth:50},
			{label: "Office", orderById: "OfficeName", data:"OfficeName",  minWidth:50},
			{label: "YRMO", orderById: "", data:"Yrmo",  minWidth:50, className:"text-left"},
			{label: "Type", orderById: "TypeId", data:(item)=>item.TypeId===1?"EOM":"Ad Hoc",  minWidth:50, className:"text-left"},
			{label: "Tipalti", orderById: "", data:item=>JsxHelper.OnlyYes(item.Tipalti),  minWidth:50, className:"text-left"},
			{label: "Started On", orderById: "", data:item=>dateTimeHelper.toYYYYsMMsDDsHHsMM(item.StartedOn),  minWidth:50, className:"text-left"},
			{label: "Finished On", orderById: "", data:item=>dateTimeHelper.toYYYYsMMsDDsHHsMM(item.FinishedOn),  minWidth:50, className:"text-left"},
			{label: "Duration", orderById: "", data:item=>dateTimeHelper.differenceTime(item.StartedOn,item.FinishedOn),  minWidth:50, className:"text-left"},
			{label: "Created On", orderById: "", data:"CreatedOn",  minWidth:50, className:"text-left"},
			{label: "Created By", orderById: "", data:item=><UserNameComponent userId={item.CreatedBy}/>,  minWidth:50, className:"text-left"},
		];
	}
	
	static GetDetailCellContent(item)
	{
		if(!item.ExportId) return null;
		return urlHelper.getIconLinkComponent(
      item.ExportId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'paymentexportdetails',
      `id=${item.ExportId}`,
      'Open up in a new tab'
    );
	}
}
